function validateHex(hex) {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
}
function hex2rgba(hex, alpha) {
  if (validateHex(hex)) {
    var r = parseInt(hex.length > 4 ? hex.slice(1, 3) : hex[1].repeat(2), 16);
    var g = parseInt(hex.length > 4 ? hex.slice(3, 5) : hex[2].repeat(2), 16);
    var b = parseInt(hex.length > 4 ? hex.slice(5, 7) : hex[3].repeat(2), 16);
    var a = Math.max(Math.min(alpha, 1));
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
  }
  throw new Error('Wrong Hex Format');
}

export { hex2rgba, validateHex };
//# sourceMappingURL=utils.js.map
